import { ToastrService } from 'ngx-toastr';
import { Component, OnInit, EventEmitter, Input, ViewChild, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { find } from 'lodash';
import { LocalDataSource } from 'ng2-smart-table';
import { Const, Documento, FuncionDocumento, ModificacionDocumento, TareaAsociacion, UsuarioActual } from '@app/shared';
import {
  Tarea,
  TaskEvent,
  Context,
  DynamicComponentForm,
  ConfigFinishDefault,
  TareaCondicion,
  ConfirmComponent
} from '@app/shared';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ApproveModifyConfig } from './shared/approve-modify-document-config.service';
import { ApproveModifyDocumentDataService } from './shared/approve-modify-document-data.service';
import { AuthenticationService } from '@app/core/authentication/authentication.service';


interface OptionCondiction {
  id_opcion: number;
  opcion: string;
  label: string;
}

@Component({
  selector: 'iw-approve-modify-document',
  templateUrl: './approve-modify-document.component.html',
  styleUrls: ['./approve-modify-document.component.scss'],
  providers: [ApproveModifyDocumentDataService]
})
export class ApproveModifyDocumentComponent extends DynamicComponentForm implements OnInit {
  // Contexto del formulario, es suministrado dinámicamente
  @Input() ctx: Context;
  // Evento para finalizar y cerrar la modal, es suministrado dinámicamente
  @Input() event: EventEmitter<TaskEvent>;
  // Define cuando activar la previsualizacion de informacion de flujo
  @Input() previewFlow = false;
   // pregunta de aprobación
   question = '¿Se aprueba la modificación de documento?';
  // tipo del proceso de la tarea renderizada
  typeProcess: string;
  // Tarea actual
  task: Tarea;
  // Determina si el usuario en sesion es responsable de la tarea
  userResponsible = false;
  // Define si la tarea esta finalizada
  finishTask = false;
  // Define si hay una secundaria iniciada
  secondaryActive = false;
  // id opcion del Sí
  idOptionAffirmative: number[] = [];
  // id opcion del No
  idOptionNegative: number[] = [];
  // Activa el btn de finalizar si hay una opción seleccionada
  isDisabledBtnFinish = true;
  // Diferentes opciones de aprovacion
  optionsPositive: Array<string> = [
    'sí', 'si'
  ];
  // Define ecuando mostrar el combo para la respuesta de aprobacion
  action = false;
  // Activa el campo de descripcion
  description = false;
  // Estdo de la tarea
  statusTask = true;
  // Define cuando se esta realizando una accion en los botones de la tabla
  buttonAction = false;
  // Condicion de la tarea
  taskCondiction: Array<TareaCondicion> = [];
  // Usuario actual en sesion
  user: UsuarioActual;
  // Documentos de la tarea de asociacion
  source: Array<ModificacionDocumento> = [];
  // Datos para llenar la tabla
  sourceData: LocalDataSource;
  // Opciones de respuesta
  options: OptionCondiction[] = [];
  // Tarea asociada
  taskAssociation: Array<TareaAsociacion>;
  // Tarea asociada
  documentsDownload: Array<any> = [];
  // Configuracion de la tabla
  settings = {};
  sourceDataHistoryModify: LocalDataSource;
  settingsHistoryModify = {};
  // Referencia de la modal
  modalRef: BsModalRef;
  // formulario de respuesta
  formRD: FormGroup = new FormGroup({
    response: new FormControl('', [Validators.required]),
    description: new FormControl(''),	
  });
  // Nombre documento seleccionado
  documentSelect: ModificacionDocumento;
  // Referencia al componente de confirmación
  @ViewChild('confirmFinish') private confirmFinish: ConfirmComponent;
  // Referencia al template de la modal de visulizacion de documento
  @ViewChild('templatePreviewDoc') private templatePreviewDoc: TemplateRef<any>;
  // Referencia al template de la modal de visulizacion de documento
  @ViewChild('templatePreviewModifyDoc') private templatePreviewModifyDoc: TemplateRef<any>;
  // Referencia al template de la modal de historial de modificaciones de documento
  @ViewChild('historyModify') private historyModify: TemplateRef<any>;
  rowSelectModify: any;

  constructor(private toastr: ToastrService,
    private dds: ApproveModifyDocumentDataService,
    private modalService: BsModalService,
    private as: AuthenticationService,
  ) {
    super();
  }

  ngOnInit() {
    this.task = this.ctx.task;
    this.typeProcess = this.ctx.typeProcess;
    // Obtener usuario autenticado
    this.user = this.as.getCredentials();
    let checkUser = this.task.responsables.find((user) => user.id === this.user.user_id);
    if (checkUser) {
      this.userResponsible = true;
    }
    if (this.task.tarea_estado.nombre === 'finalizado' || !this.userResponsible) {
      this.statusTask = false;
    }
    if(this.previewFlow){
      this.finishTask = true;
      this.statusTask = false;
    }
    if (
      this.task &&
      this.task.tarea_estado &&
      this.task.tarea_estado.nombre === Const.STATUS_TASK.finished
    ) {
      this.finishTask = true;
    }
    if (
      this.task &&
      this.task.tarea_estado &&
      this.task.tarea_estado.nombre === Const.STATUS_TASK.secondaryProgress
    ) {
      this.secondaryActive = true;
    }
    
    this.taskAssociation = this.task.tarea_asociacion;
    this.taskCondiction = <TareaCondicion[]>this.task.tarea_condicion;
    const docsC = new ApproveModifyConfig();
    this.settings = docsC.settings;
    docsC.accion.subscribe((data: any) => {
      this.buttonAction = true;
      this.accionTable(data);
    });
    this.loadingDocs();
    this.loadingCondiction();
    this.optionCondition();
    this.validReview();
  }

  ngOnDestroy() {
    this.documentSelect = null;
    this.source = [];
    this.options = [];
    this.taskAssociation = [];
    this.taskCondiction = [];
    this.task = null;
  }

  /**
   * Finalizar la tarea.
   *
   * @param {boolean} res
   * @memberof ApproveModifyDocumentComponent
   */
  finish(res: boolean) {
    const opcion = this.validapprovals();
    if (res) {
      const data: ConfigFinishDefault = {
        tarea: this.task.id,
        id_opciones: opcion
      };
      const e: TaskEvent = {
        type: 'finish',
        data: data
      };
      this.event.emit(e);
      this.close();
    }
  }

  /**
   * Define los id de las opciones de finalizacion
   *
   * @private
   * @memberof ApproveModifyDocumentComponent
   */
  private optionCondition() {
    (<TareaCondicion[]>this.task.tarea_condicion).forEach(condition => {
      const existPositive = this.optionsPositive.indexOf(condition.opcion.toLowerCase());
      if (existPositive !== -1) {
        this.idOptionAffirmative.push(condition.id_opcion);
      } else {
        this.idOptionNegative.push(condition.id_opcion);
      }
    });
  }

  /**
   * Valida las revisiones para activar el boton de finalizar
   *
   * @private
   * @memberof ApproveModifyDocumentComponent
   */
  private validReview() {
    let valid = false;
    const documents: Array<ModificacionDocumento> = [];
    this.task.tarea_asociacion.forEach(taskAssociation => {
      taskAssociation.documentos_modificacion.forEach(document => {
        documents.push(document);
      });
    });
    if (documents.length) {
      if (documents[0].fecha_aprobacion) {
          valid = true;
      }
    }
    if (valid) {
      this.isDisabledBtnFinish = false;
    } else {
      this.isDisabledBtnFinish = true;
    }
  }

  /**
   * Valida las revisiones de los documentos si estan con accion positiva o hay almenos un documento con una
   * accion negativa y retorna el id de la opcion correspondiente
   *
   * @private
   * @returns {number}
   * @memberof ApproveModifyDocumentComponent
   */
  private validapprovals(): number[] {
    let disapprove = 0;
    this.taskAssociation.forEach(task => {
      if (task.documentos_modificacion.length > 0) {
        let document: ModificacionDocumento = task.documentos_modificacion[0];
        if (document.aprobacion === false) {
          disapprove += 1;
        }
      }
    });
    if (disapprove > 0) {
      return this.getOptionsFinish(false);
    } else {
      return this.getOptionsFinish(true);
    }
  }

  /**
   * Validad que la tarea se pueda finalizar
   *
   * @memberof ApproveModifyDocumentComponent
   */
  finishConfirm() {
    if (!this.isDisabledBtnFinish && this.userResponsible && !this.finishTask && !this.secondaryActive) {
      this.confirmFinish.open();
    } else {
      if (!this.userResponsible) {
        this.toastr.error('Usted no posee los permisos suficientes para ejecutar esta acción.', 'Permiso denegado');
      } else if (this.finishTask) {
        this.toastr.error('La tarea ya está finalizada.', 'Acción no permitida');
      } else if (this.secondaryActive) {
        this.toastr.error(
          'No se puede realizar esta acción debido a que se encuentra un procesos secundario en progreso.',
          'Acción no permitida'
        );
      } else if (this.isDisabledBtnFinish) {
          this.toastr.error('Por Favor ingrese toda la información requerida.', 'Información incompleta');
      } else {
        this.toastr.error(
          'Lo sentimos ha ocurrido un error inesperado, inténtalo de nuevo más tarde.',
          'Error inesperado'
        );
      }
    }
  }

  /**
   * Retorna las opciones de finalizacion de la tarea
   * vasado en las opciones de revisiones seleccionadas
   * a los diferentes documentos de la tarea
   *
   * @private
   * @param {boolean} approve
   * @memberof ApproveModifyDocumentComponent
   */
  private getOptionsFinish(approve: boolean): number[] {
    const optionsFinish: number[] = [];
    if (approve) {
      for (let index = 0; index < this.idOptionAffirmative.length; index++) {
        optionsFinish.push(this.idOptionAffirmative[index]);
      }
    } else {
      for (let index = 0; index < this.idOptionNegative.length; index++) {
        optionsFinish.push(this.idOptionNegative[index]);
      }
    }
    return optionsFinish;
  }

  /**
   * previsulizar el archivo del documento selecionado
   *
   * @private
   * @param {*} data
   * @returns {*}
   * @memberof ApproveModifyDocumentComponent
   */
 private preview(data: number): any {
  this.dds.dowloadModifyFile(data).subscribe((res: any) => {
    this.modalRef = this.modalService.show(this.templatePreviewDoc, { class:  'modal-personalized', initialState: res.file});
    let type = res.file.path.split(".").pop();
    let document = {"tipo": type, "ruta": res.file.path, "rutaGoogle": "https://docs.google.com/gview?url="+ res.file.path+"&embedded=true",
    "rutaMicrosoft":"https://view.officeapps.live.com/op/view.aspx?src="+res.file.path+"&wdOrigin=BROWSELINK"} 
    this.modalRef.content = document;
  });
}

  /**
   * Desacarga el archivo del documento selecionado
   *
   * @private
   * @param {*} data
   * @returns {*}
   * @memberof ApproveModifyDocumentComponent
   */
  private downloadModify(data: number): any {
    this.dds.dowloadModifyFile(data).subscribe((res: any) => {
      const a = document.createElement('a');
      a.target = '_blank';
      a.href = res.file.path;
      a.download = res.file.name;
      a.click();
      a.remove();
    });
  }

  /**
   * previsulizar el archivo del documento selecionado
   *
   * @private
   * @param {*} data
   * @returns {*}
   * @memberof ApproveModifyDocumentComponent
   */
 private previewModify(data: number): any {
  this.dds.dowloadModifyFile(data).subscribe((res: any) => {
    this.modalRef.hide();
    this.modalRef = this.modalService.show(this.templatePreviewModifyDoc, { class:  'modal-personalized', initialState: res.file});
    let type = res.file.path.split(".").pop();
    let document = {"tipo": type, "ruta": res.file.path, "rutaGoogle": "https://docs.google.com/gview?url="+ res.file.path+"&embedded=true",
    "rutaMicrosoft":"https://view.officeapps.live.com/op/view.aspx?src="+res.file.path+"&wdOrigin=BROWSELINK"} 
    this.modalRef.content = document;
  });
}


  /**
   * Controla las acciones en la tabla de los botones
   *
   * @private
   * @param {*} data
   * @returns {*}
   * @memberof ApproveModifyDocumentComponent
   */
  private accionTable(data: any): any {
    if (data.accion === 'download') {
      this.documentsDownload.push(data.data);
      this.downloadModify(data.data);
    } else if(data.accion === 'preview'){
      this.documentsDownload.push(data.data);
      this.preview(data.data);
    }else if (data.accion === 'modify') {
      this.getHistoryModify(data.data);
      //this.reviewDocument(data.data);
    }
     else if (data.accion === 'error') {
      this.toastr.error(data.message, 'Error de accion');
    }
  }

   /**
   * Cargar los documentos de la tarea.
   *
   * @memberof ApproveModifyDocumentComponent
   */
   loadingDocs() {
    this.source = [];
    this.taskAssociation.forEach(task => {
      if (task.documentos_modificacion.length > 0) {
        let document: ModificacionDocumento = task.documentos_modificacion[0];
        if (document.clasificacion){
          document.nombre = document.clasificacion;
        }else{
          document.nombre = document.tipo_documental;
        }
        this.source.push(document);
      }
    });
    this.sourceData = new LocalDataSource(this.source);
  }

  /**
   * Define la accion a realizar dependiendo de la opcion seleccionada en la tabla
   *
   * @private
   * @param {*} data
   * @returns {*}
   * @memberof ApproveModifyDocumentComponent
   */
  private accionTableModify(data: any): any {
    if (data.accion === 'download') {
      this.downloadModify(data.data);
    } else if(data.accion === 'preview'){
        this.previewModify(data.data);
    }
     else if (data.accion === 'error') {
      this.toastr.error(data.message, 'Error de accion');
    }
  }

  /**
   * Setea la data de el componente de revisiones del documento
   *
   * @private
   * @param {*} data
   * @returns {*}
   * @memberof ApproveModifyDocumentComponent
   */
  private getHistoryModify(data: any): any {
    this.rowSelectModify = data;
    this.modalRef = this.modalService.show(this.historyModify, { class: 'modal-personalized', initialState: data });
    let source: any[] = [];
    this.task.documentos_modificacion.forEach(modify => {
      if (modify.fecha) {
        const date = new Date(modify.fecha);
        modify.fecha = date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
      }
      if(modify.fecha_aprobacion){
        const date = new Date(modify.fecha_aprobacion);
        modify.fecha_aprobacion = date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
      }
      source.push(modify);
    });
    this.sourceDataHistoryModify = new LocalDataSource(source);
    const docsModify = new ApproveModifyConfig();
    this.settingsHistoryModify = docsModify.settingsHistoryModify;
    docsModify.accionModify.subscribe(async (data: any) => {
      this.accionTableModify(data);
    });
    let modalContent = {
      settingsModify: this.settingsHistoryModify,
      source: this.sourceDataHistoryModify
    };
    this.modalRef.content = modalContent;
  }


  /**
   * Carga la pregunta y las condiciones
   *
   * @private
   * @memberof ApproveModifyDocumentComponent
   */
  private loadingCondiction() {
    if (this.taskCondiction.length > 0) {
      let condiction: TareaCondicion;
      condiction = this.taskCondiction[0];
      this.question = condiction.tarea_condicion;
      this.taskCondiction.forEach(con => {
        if (con.alias === condiction.alias) {
          this.options.push({
            id_opcion: con.id_opcion,
            opcion: con.opcion,
            label: con.mascara ? con.mascara : con.opcion
          });
        }
      });
    }
  }

  /**
   * cierra el modal con el la previsualizacion de documento
   *
   * @memberof ApproveModifyDocumentComponent
   */
  closeModalPreviewModifyDoc() {
    this.modalRef.hide();
    this.getHistoryModify(this.rowSelectModify);
  }

  /**
   * Se encarga de controlar el evento de clic en el las filas de la tabla
   *
   * @param {*} data
   * @memberof ApproveModifyDocumentComponent
   */
  rowSelect(data: any) {
    if (!this.buttonAction) {
      if (this.statusTask && this.userResponsible) {
        this.documentSelect = data.data;
        this.formRD.reset({ response: '', description: '' });
        this.description = false;
        if (
          this.documentSelect
        ) {
          for (let index = 0; index < this.documentsDownload.length; index++) {
            if (this.documentsDownload[index] === this.documentSelect.id) {
              this.action = true;
              break;
            } else {
              this.action = false;
            }
          }
        } else {
          this.action = false;
        }
        if (!this.action) {
          this.toastr.warning('Para dar respuesta a este documento debe descargarlo primero', 'Acción no permitida', {
            positionClass: 'toast-top-center'
          });
        }
      }
    } else {
      this.buttonAction = false;
    }
  }

    /**
   * Se ejecuta cada vez que se realiza un cambio de opcion en el select de las opciones de respuesta
   * para mostrar el campo de descripcion dependiendo de la opcion seleccionada
   *
   * @memberof ApproveModifyDocumentComponent
   */
    changeResponse() {
      const response = find(this.options, {id_opcion: this.formRD.value.response});
      if (response.opcion.toLowerCase() === 'no') {
        this.description = true;
        this.formRD.controls.description.setValidators([Validators.required]);
      } else {
        this.description = false;
        this.formRD.controls.description.clearValidators();
        this.formRD.controls.description.reset();
      }
    }

  /**
   * Guarda la respuesta y actualiza la informacion de los documentos y la tarea
   *
   * @memberof ApproveModifyDocumentComponent
   */
  saveResponse() {
    const review: any = {
      documento_id: this.documentSelect.id,
      tarea_id: this.task.id,
      motivo: this.formRD.value.description,
    };
    const response = find(this.options, {id_opcion: this.formRD.value.response});
    if (response.opcion.toLowerCase() === 'no') {
      review.aprobacion = false;
    } else {
      review.aprobacion = true;
    }
    this.dds.saveReviewDocument(review).subscribe((res: any) => {
      this.formRD.reset({ response: '', description: ''});
      this.description = false;
      this.action = false;
      this.taskAssociation[0].documentos_modificacion = [res];
      this.loadingDocs();
      this.validReview();
      this.toastr.success('La accion se a realizado con exito', 'Accion exitosa');
    },err=>{
      if (err.error == "Código suminstrado no valido"){
        this.formRD.controls.txtCodigo.reset()
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/forms/all/approve-modify-document/approve-modify-document.component.ts